import { Mars, Venus, Transgender, CircleDot, User } from "lucide-react";

export const GENDERS = [
  { v: "male", l: "Male", Icon: Mars },
  { v: "female", l: "Female", Icon: Venus },
  { v: "transgender", l: "Transgender", Icon: Transgender },
  { v: "non_binary", l: "Non-binary", Icon: CircleDot },
  { v: "other", l: "Other", Icon: User },
];

export const GENDER_MAP = Object.fromEntries(GENDERS.map((g) => [g.v, g]));
export const GENDER_LABELS = Object.fromEntries(GENDERS.map((g) => [g.v, g.l]));

export function GenderIcon({ gender, className }) {
  const g = GENDER_MAP[gender];
  if (!g) return null;
  const Icon = g.Icon;
  return <Icon className={className || "w-3.5 h-3.5"} />;
}
